import { Link } from 'react-router-dom';
import RoleGate from '@/components/RoleGate';

const ENTRIES = [
  { icon: 'ri-pulse-line', title: '平台健康总览', desc: '服务可用性与错误趋势（建设中）' },
  { icon: 'ri-plug-line', title: 'Provider / API 状态摘要', desc: '供应商连通与成功率摘要，不含完整 Key（建设中）' },
  { icon: 'ri-bug-line', title: '任务诊断入口', desc: '生成任务失败排查（建设中）' },
  { icon: 'ri-stack-line', title: 'Queue / 高并发监控', desc: '排队与并发水位（建设中）' },
  { icon: 'ri-error-warning-line', title: 'UX Error Delta', desc: '前端错误与体验回归（建设中）' },
  { icon: 'ri-settings-3-line', title: '系统设定 / 权限 Debug', desc: '平台级设定与权限调试（建设中）' },
];

export default function ReliabilityConsolePage() {
  return (
    <RoleGate allow={['dev_admin']} deniedTitle="此页仅限平台稳定管理员">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="flex items-center gap-2 text-xs text-secondary-400 mb-2">
          <Link to="/" className="hover:text-foreground-600">工作台</Link>
          <i className="ri-arrow-right-s-line" />
          <span>平台稳定控制台</span>
        </div>
        <h1 className="text-2xl font-bold text-foreground-950">Platform Reliability Console</h1>
        <p className="text-sm text-foreground-600 mt-1 mb-4">平台稳定、Provider 摘要、任务诊断与 Queue 监控入口。本阶段为占位，完整功能后续迭代。</p>
        <div className="flex flex-wrap gap-2 mb-6">
          <a href="/admin/operations" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-primary-500 text-background-50 text-xs font-semibold hover:bg-primary-600">
            <i className="ri-dashboard-3-line" />完整营运后台
          </a>
          <a href="/admin/business" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-secondary-200 text-xs font-medium text-foreground-700 hover:bg-secondary-50">
            商业营运控制台
          </a>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {ENTRIES.map((e) => (
            <div key={e.title} className="rounded-xl border border-secondary-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className={`${e.icon} text-primary-500`} />
                {e.title}
              </div>
              <p className="text-xs text-secondary-500 mt-2">{e.desc}</p>
              <span className="inline-block mt-3 text-[10px] px-2 py-0.5 rounded bg-secondary-100 text-secondary-500">建设中</span>
            </div>
          ))}
        </div>
      </div>
    </RoleGate>
  );
}
